import {observer} from "mobx-react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from "@mui/material";
import React, {useState} from "react";
import CloseIcon from "@mui/icons-material/Close";
import ContactPage from "../Contact/ContactPage";
import {useStore} from "../../stores/Store";
import Accordion from "../../models/Accordion";
import {DoubleArrow} from "@mui/icons-material";

interface Props {
    accordion: Accordion
}

const AccordionContactMeDialog = ({accordion}: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const {
        ContactFormStore: {setAdditionalInformationFromString},
        LanguageStore: {currentLanguageMessages}
    } = useStore();
    
    const openModal = () => {
        setAdditionalInformationFromString(`${currentLanguageMessages.AccordionsPage.accordionAdditionalInformationContactText} ${accordion.name}`);
        setIsOpen(true);
    }
    
    const closeModal = () => {
        setAdditionalInformationFromString('');
        setIsOpen(false);
    }
    
    return (
        <>
            <Button
                variant={'outlined'}
                color={'secondary'}
                onClick={openModal}
                startIcon={<DoubleArrow />}
            >
                {currentLanguageMessages.NavBar.ContactTitle}
            </Button>
            <Dialog open={isOpen} maxWidth={'md'} fullWidth={true}>
                <DialogTitle sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Typography variant={'h5'} sx={{mt: 0.5}}>Contact</Typography>
                    <IconButton onClick={closeModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <ContactPage showAreasOfInterest={false} showMap={false} />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default observer(AccordionContactMeDialog);